/* Le Feu Konfigurator (Claude, 2026-10-06)
   Produktwechsel (Modell, Hoehe, Saeule, Farbe) uebernimmt die gerade gewaehlten Optionen.
   Die Links kommen mit der Variante vom Seitenaufruf aus Liquid. Hat der Kunde danach Glas,
   Standfuesse, Brenner usw. umgestellt, wird vor dem Wechsel die passende Variante des Zielprodukts
   gesucht (gleicher Optionsname, gleicher Wert). Faellt der Abruf aus, gilt der Liquid-Link.
   Dazu: Wunschfarbe-RAL-Kachel in der Farb-Ebene (syncRal, InFire).
   Laeuft nach wfk-konfigurator.js, damit dessen Merker (offene Ebene, Scrollposition) gesetzt bleibt. */
(function () {
  'use strict';

  var saleTimer;
  function expireModelSales() {
    clearTimeout(saleTimer);
    var now = Date.now();
    var next = Infinity;
    document.querySelectorAll('.lf-grid--mod [data-lf-sale-until]').forEach(function (price) {
      var until = Number(price.getAttribute('data-lf-sale-until'));
      if (!Number.isFinite(until) || now >= until) {
        price.textContent = price.getAttribute('data-lf-regular-price');
        price.removeAttribute('data-lf-sale-until');
        price.removeAttribute('data-lf-regular-price');
      } else {
        next = Math.min(next, until - now);
      }
    });
    if (next !== Infinity) saleTimer = setTimeout(expireModelSales, Math.min(next, 60000));
  }
  if (document.readyState !== 'loading') expireModelSales();
  else document.addEventListener('DOMContentLoaded', expireModelSales);
  window.addEventListener('pageshow', expireModelSales);
  document.addEventListener('visibilitychange', expireModelSales);
  document.addEventListener('shopify:section:load', expireModelSales);

  function selection(scope) {
    var m = {};
    Array.prototype.forEach.call(scope.querySelectorAll('.lf--var input[data-variant-input]:checked'), function (i) {
      m[i.name] = i.value;
    });
    return m;
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.lf a[data-wfk-nav]');
    if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var scope = a.closest('.product-section') || document;
    var box = scope.querySelector('.lf--var');
    var sel = scope.querySelector('[data-product-select]');
    if (!box || !sel || sel.value === box.getAttribute('data-lf-init')) return;

    var cur = selection(scope);
    /* Farb-Kachel neben „Wunschfarbe RAL“: andere Farbe heisst Standardlackierung, RAL nicht mitnehmen */
    var stdName = a.getAttribute('data-lf-std');
    if (stdName) delete cur[stdName];
    var base = a.pathname;
    var done = false;
    function go(u) { if (done) return; done = true; window.location.href = u; }
    e.preventDefault();
    var timer = setTimeout(function () { go(a.href); }, 1500);

    fetch(base + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var names = (p.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; });
        var best = null, bs = -1;
        (p.variants || []).forEach(function (v) {
          var s = 0;
          names.forEach(function (n, i) {
            if (cur[n] !== undefined && v.options[i] === cur[n]) s += 2;
            if (stdName && n === stdName && /wunschfarbe/i.test(v.options[i] || '')) s -= 3;
          });
          if (v.available) s += 1;
          if (s > bs) { bs = s; best = v; }
        });
        clearTimeout(timer);
        go(best && bs > 1 ? base + '?variant=' + best.id : a.href);
      })
      .catch(function () { clearTimeout(timer); go(a.href); });
  });

  /* InFire: Wunschfarbe RAL als Kachel in der Farb-Ebene (if-konfigurator). Die Kacheln sind label fuer die
     Radios der ausgeblendeten Varianten-Ebene; hier folgen Auswahlring und Kopfzeile dem gewaehlten Radio. */
  function syncRal() {
    Array.prototype.forEach.call(document.querySelectorAll('details[data-lf-ral]'), function (lv) {
      var tiles = lv.querySelectorAll('[data-lf-ral-tile]');
      var on = null;
      Array.prototype.forEach.call(tiles, function (t) {
        var inp = document.getElementById(t.getAttribute('for'));
        var sel = !!(inp && inp.checked);
        t.classList.toggle('is-sel', sel);
        t.setAttribute('aria-pressed', sel ? 'true' : 'false');
        if (sel) on = t;
      });
      if (!on) return;
      var hv = lv.querySelector('[data-lf-hval]');
      var hi = lv.querySelector('[data-lf-hico]');
      var ico = on.querySelector('.wfk-t__ico');
      if (hv) hv.textContent = on.getAttribute('data-lf-name') || '';
      if (hi && ico) hi.innerHTML = ico.innerHTML;
    });
  }
  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('input[data-variant-input]')) setTimeout(syncRal, 0);
  });
  document.addEventListener('variant:change', function () { setTimeout(syncRal, 0); });
  document.addEventListener('keydown', function (e) {
    var t = e.target && e.target.closest && e.target.closest('[data-lf-ral-tile]');
    if (t && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); t.click(); }
  });
  if (document.readyState !== 'loading') syncRal(); else document.addEventListener('DOMContentLoaded', syncRal);
})();
